export const tourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
  },
  useModalOverlay: true,
};

const closingModalOnOutsideClick = () => {
  const element: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName(
    'shepherd-modal-overlay-container'
  ) as HTMLCollectionOf<HTMLElement>;

  if (element && element.length > 0 && element[0]) {
    const subElement = element[0] as HTMLElement;
    subElement.onclick = () => {
      const newElement: HTMLCollectionOf<HTMLElement> = document.getElementsByClassName(
        'shepherd-cancel-icon'
      ) as HTMLCollectionOf<HTMLElement>;
      if (newElement && newElement.length > 0 && newElement[0]) {
        newElement[0].click();
      }
    };
  }
};
const genratingCommonSteps = (id, className, position, title, text, isLast) => {
  return {
    id: id,
    attachTo: { element: `.${className}`, on: position },
    title: title,
    text: text,
    canClickTarget: false,
    buttons: !isLast
      ? [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back',
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Next',
            type: 'next',
          },
        ]
      : [
          {
            classes: 'shepherd-button-primary',
            text: 'Back',
            type: 'back',
          },
          {
            classes: 'shepherd-button-primary',
            text: 'Finish',
            type: 'next',
          },
        ],
  };
};

export const jobListSteps = [
  {
    ...genratingCommonSteps(
      'Smart Filters',
      'smart-filters',
      'left',
      'Smart Filters',
      `
    Search with Keywords OR Boolean Strings.
    </br>
    </br>
    Use Smart Filters like Dates, Submission Count, Account Managers for Rapid Searches.
    </br>
    </br>
    Clear to restart. `,
      false
    ),
    beforeShowPromise: () => {
      const element: HTMLElement = document.getElementsByClassName(
        'close-drawer'
      )[0] as HTMLElement;
      element && element.click();
      closingModalOnOutsideClick();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 200);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Advanced Filters',
      'job-listing-advanced-filters',
      'left',
      'Advanced Filters',
      'Use 10 Advanced Filters to find the exact Job you are looking for.',
      false
    ),
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        const element: HTMLElement = document.getElementsByClassName(
          'advanced-filter'
        )[0] as HTMLElement;
        element.click();
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Download JD',
      'download-jd',
      'left',
      'Download JD',
      'Download JDs into a beautiful and ready to send PDF to candidates',
      false
    ),
    beforeShowPromise: () => {
      const element: HTMLElement = document.getElementsByClassName(
        'close-drawer'
      )[0] as HTMLElement;
      element && element.click();
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 200);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'AI Boolean',
      'ai-boolean',
      'left',
      'AI Boolean',
      `Use our AI powered Boolean String Generator to search Candidates on Job Boards. 
          </br>
          </br>
         Just copy the Boolean String and start searching .`,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 220);
          resolve(true);
        }, 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Publish Jobs',
      'publish-jobs',
      'left',
      'Publish Jobs',
      `
        Single click Job Publishing to 16 + Job boards globally.
        </br>
        </br>
        Reach thousands of interested applicants.`,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 200);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Find Candidates',
      'find-candidates',
      'right',
      'Find Candidates',
      `
        Get AI matched Candidates from your Talent pool instantly.
        </br>
        </br>
        Single Click Search on Dice, Careerbuilder, Techfetch and Monster.  `,
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 200);
      });
    },
  },
];

export const talentpoolSteps = [
  {
    ...genratingCommonSteps(
      'Talent Pool Search',
      'talentpool-filters',
      'left',
      'Talent pool Search',
      `
    Search by Keywords or Boolean. 
    </br>
    </br>
    Use 15+ advanced Filters to find exactly what you are looking for
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      closingModalOnOutsideClick();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Integrated Database Search',
      'integrated-database-search',
      'right',
      'Integrated Database Search',
      `
      Search Candidates on 5+ configured Databases from within Wisestep.
    </br>
    </br>
    Save upto $2500 per month by Sharing Database Logins and CV views. 
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 300);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Setup a Reminder',
      'add-a-reminder',
      'left',
      'Add Reminder',
      `
      Add Reminders to follow up with great candidates and improve your submission ratio.
    </br>
    </br>
    Successful recruiters follow up 3 X  more than an average Recruiter.  
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 300);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'View Candidate Profiles',
      'view-candidate-profile',
      'right-start',
      'View Candidate Profiles',
      `
    View Candidate Profiles in a beautiful and easy to use layout.
    </br>
    </br>
    Flip through Candidate profiles 50% faster and contact Candidates instantly with Email and SMS to get faster responses. 
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 300);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Map as Lead ',
      'map-as-lead',
      'top',
      'Map as Lead ',
      `
      Add Candidates to your Shortlist Funnel for every job you work on.
    </br>`,
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 300);
      });
    },
  },
];

export const mappingSteps = [
  {
    ...genratingCommonSteps(
      'Resume Files ',
      'resume-files',
      'bottom',
      'Resume Files ',
      `
      View all the resumes in the Talent Pool that are tagged to this Candidate.
    </br>
    </br>
    Download the resumes for submissions. 
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      closingModalOnOutsideClick();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },

  {
    ...genratingCommonSteps(
      'Select a Job to Work on ',
      'change-job',
      'bottom',
      'Select a Job to Work on ',
      `
      Select a Job to add the current Candidate to it.
    </br>
    </br>
    Track and manage all conversations with that candidate for that job easily.   
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },

  {
    ...genratingCommonSteps(
      'Data Privacy',
      'data-privacy',
      'left',
      'Data Privacy',
      `
      Manage Candidate Data privacy options by adding them to or removing them from Delete or Do not Contact Statuses. `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        const element: HTMLElement = document
          .getElementsByClassName('scrollable-tabs')[0]
          .getElementsByClassName('MuiButtonBase-root')[5] as HTMLElement;
        element.click();
        setTimeout(() => resolve(true), 200);
      });
    },
  },

  {
    ...genratingCommonSteps(
      'Quick Actions ',
      'quick-actions',
      'top',
      'Quick Actions',
      `
      Quick actions to start and manage Conversations with Candidates . `,
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        const element: HTMLElement = document
          .getElementsByClassName('scrollable-tabs')[0]
          .getElementsByClassName('MuiButtonBase-root')[1] as HTMLElement;
        element.click();
        setTimeout(() => resolve(true), 200);
      });
    },
  },
];

export const pipelineSteps = [
  {
    ...genratingCommonSteps(
      'pipeline Search',
      'pipeline-filters',
      'left',
      'Pipeline Search',
      `
    Search by Keywords or Boolean. 
    </br>
    </br>
    Use 21 advanced Filters to find exactly what you are looking for.
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      closingModalOnOutsideClick();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Integrated Database Search',
      'integrated-database-search',
      'right',
      'Integrated Database Search',
      `
      Search Candidates on 5+ configured Databases from within Wisestep.
    </br>
    </br>
    Save upto $2500 per month by Sharing Database Logins and CV views. 
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 300);
      });
    },
  },

  {
    ...genratingCommonSteps(
      'Search By Actions',
      'search-by-actions',
      'left',
      'Search By Actions',
      `
      Search by Recruiter Actions and Candidate Responses For specific follow ups.
    </br>
    </br>
    Example: Search for Candidates that "You left a Voice Mail" OR those where " Waiting for CV" .  
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 300);
      });
    },
  },

  {
    ...genratingCommonSteps(
      'Setup a Reminder',
      'setup-a-reminder',
      'left',
      'Add Reminder',
      `
      Add Reminders to follow up with great candidates and improve your submission ratio.
    </br>
    </br>
    Successful recruiters follow up 3 X  more than an average Recruiter.  
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 300);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'View Candidate Profiles',
      'view-mapped-candidate-profile',
      'right-start',
      'View Candidate Profiles',
      `
    View Candidate Profiles in a beautiful and easy to use layout.
    </br>
    </br>
    Flip through Candidate profiles 50% faster and contact Canidates instantly with Email and SMS to get faster responses. 
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 300);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Map as Lead ',
      'candidate-map-as-lead',
      'left',
      'Map as Lead ',
      `
      Add Candidates to your Shortlist Funnel for every job you work on.
    </br>`,
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 300);
      });
    },
  },
];
export const jobcrmSteps = [
  {
    ...genratingCommonSteps(
      'Social Search ',
      'social-search',
      'top',
      'Social Search ',
      `
      Search Google, Linkedin , Indeed and more instantly with our AI generated Search Strings.`,
      false
    ),
    beforeShowPromise: () => {
      closingModalOnOutsideClick();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Pipelines',
      'pipelines',
      'left',
      'Pipelines',
      `
      Track your Candidates from Uploads, Applications, Mappings to Submissions. `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'AI Smart Source',
      'smart-source',
      'left',
      'AI Smart Source',
      `
      Get upto 100 AI matched Candidate recommendations from your Talent Pool instantly. 
    </br>
    </br>
    Start Candidate Conversations in 60 seconds of accepting a new Job.
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Analytics Insights ',
      'analytics-insights',
      'right',
      'Analytics Insights ',
      `
      Get upto 100 AI matched Candidate recommendations from your Talent Pool instantly. 
    </br>
    </br>
    Start Candidate Conversations in 60 seconds of accepting a new Job.
    </br> `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Send Email',
      'contact-email',
      'left',
      'Send Email',
      `
      Track and manage email conversations with your pipeline candidates. `,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 120);
          resolve(true);
        }, 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Send SMS',
      'contact-phone',
      'top',
      'Send SMS',
      `
      Track, manage and communicate with your Candidates using SMS.
      </br>
      </br>
      SMS Open rates are 80% + and response times are in minutes.  `,
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 250);
      });
    },
  },
];

export const submissionSteps = [
  {
    ...genratingCommonSteps(
      'Smart Filters',
      'submission-filters',
      'left',
      'Smart Filters ',
      `
      Use Smart Filters like Submitted Dates, Account Managers and Candidate Status for Rapid Searches.`,
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Sort',
      'sort',
      'left',
      'Sort ',
      `
      Sort in ascending or descending order by date of submissions. `,
      false
    ),
    beforeShowPromise: () => {
      const element: HTMLElement = document.getElementsByClassName(
        'close-drawer'
      )[0] as HTMLElement;
      element && element.click();
      return new Promise(function (resolve) {
        setTimeout(() => resolve(true), 200);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Advanced Filters',
      'submission-advanced-filters',
      'left',
      'Advanced Filters',
      'Use 14 Advanced Filters to find the Submitted Candidates you are looking for.',
      false
    ),
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        const element: HTMLElement = document.getElementsByClassName(
          'advanced-filter'
        )[0] as HTMLElement;
        element.click();
        setTimeout(() => resolve(true), 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Index Filters',
      'index-filters',
      'right',
      'Index Filters',
      `Filter candidates based on pipeline Stage instantly.
      </br>
      </br>
      Drill down easily to reach candidates that matter.`,
      false
    ),
    beforeShowPromise: () => {
      const element: HTMLElement = document.getElementsByClassName(
        'close-drawer'
      )[0] as HTMLElement;
      element && element.click();
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 140);
          resolve(true);
        }, 200);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Update Status ',
      'update-status',
      'left',
      'Update Status ',
      'Update Candidate Status and Track your pipelines ',
      false
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 140);
          resolve(true);
        }, 250);
      });
    },
  },
  {
    ...genratingCommonSteps(
      'Clear Tags',
      'clear-tags',
      'left',
      'Clear Tags',
      'Clear Tags of Submission Status to  clear any existing filters.  ',
      true
    ),
    beforeShowPromise: () => {
      return new Promise(function (resolve) {
        setTimeout(() => {
          window.scrollTo(0, 0);
          resolve(true);
        }, 250);
      });
    },
  },
];
